var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_7464)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_408_7464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.575 14.5749C14.8563 14.2937 15.2378 14.1357 15.6355 14.1357C16.0333 14.1357 16.4148 14.2937 16.696 14.5749L22 19.8789L27.304 14.5749C27.5869 14.3017 27.9658 14.1505 28.3591 14.1539C28.7524 14.1573 29.1287 14.3151 29.4068 14.5932C29.6849 14.8713 29.8426 15.2475 29.8461 15.6408C29.8495 16.0341 29.6983 16.413 29.425 16.6959L24.121 21.9999L29.425 27.3039C29.6983 27.5868 29.8495 27.9657 29.8461 28.359C29.8426 28.7523 29.6849 29.1285 29.4068 29.4066C29.1287 29.6848 28.7524 29.8425 28.3591 29.8459C27.9658 29.8493 27.5869 29.6982 27.304 29.4249L22 24.1209L16.696 29.4249C16.4131 29.6982 16.0342 29.8493 15.6409 29.8459C15.2476 29.8425 14.8714 29.6848 14.5933 29.4066C14.3152 29.1285 14.1575 28.7523 14.154 28.359C14.1506 27.9657 14.3018 27.5868 14.575 27.3039L19.879 21.9999L14.575 16.6959C14.2938 16.4146 14.1359 16.0332 14.1359 15.6354C14.1359 15.2377 14.2938 14.8562 14.575 14.5749Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_408_7464",
    x: 4.13586,
    y: 4.13574,
    width: 35.7102,
    height: 35.7102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_408_7464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_408_7464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_7464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ec0274948f588c1403149349e13ffe6c.svg";
export { ForwardRef as ReactComponent };